if (!customElements.get('login-section')) {
    // js/sections/LoginSection.js
    class LoginSection extends HTMLElement {
    constructor() {
        super();
        this.domDelegate = new main_default(this);
        this.customerLoginForm = this.querySelector("#customer_login");
        this.recoverPasswordForm = this.querySelector("#recover_customer_password");
        this.domDelegate.on("click", '[data-action="toggle-login-form"]', this._showRecoverPassword.bind(this));
    }
    _showRecoverPassword() {
        let isLoginActive = this.customerLoginForm.style.display === "block";
        if (isLoginActive) {
        this.customerLoginForm.style.display = "none";
        this.recoverPasswordForm.style.display = "block";
        } else {
        this.customerLoginForm.style.display = "block";
        this.recoverPasswordForm.style.display = "none";
        }
    }
    };

    customElements.define('login-section', LoginSection);
}